import Vue from 'vue';

import { Nullable } from '@/utils/types';

export const RequestAbortMixin = Vue.extend({
  data: (): { abortController: Nullable<AbortController> } => ({
    abortController: null,
  }),

  methods: {
    handleRequestAbort: function () {
      if (!this.abortController) {
        this.abortController = new AbortController();
        return;
      }

      this.abortController.abort();
      this.abortController = new AbortController();
    },
  },
});
